// ============================================================
// Loader — Full-screen & Inline Loading Spinner
// ============================================================

import { Box, CircularProgress, Typography } from '@mui/material';
import { tokens } from '@/theme/tokens';

export function Loader({ fullScreen = false, message = 'Loading...', size = 40 }) {
  if (fullScreen) {
    return (
      <Box
        sx={{
          position: 'fixed',
          inset: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: tokens.colors.background,
          zIndex: tokens.zIndex.overlay,
          gap: 2,
        }}
      >
        <CircularProgress size={size} sx={{ color: tokens.colors.primary.main }} />
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 6,
        gap: 2,
      }}
    >
      <CircularProgress size={size} sx={{ color: tokens.colors.primary.main }} />
      {message && (
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      )}
    </Box>
  );
}
